import React, { forwardRef, useEffect, useState } from "react";
import { apsisEncrypt } from "../../helpers/apsisEncryption";
import fetchWrapper from "../../helpers/fetchWrapper";
import { Select } from "antd";

export const FormSelect = forwardRef(
  (
    {
      value = "",
      onChange,
      getEvent,
      name,
      slug,
      dropdownOptions,
      extra,
      disabledOptions = [],
      selectValueConvertNumber = true,
      errors,
      defaultSelect = true,
      ...rest
    },
    ref
  ) => {
    const { Option } = Select;
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedValue, setSelectedValue] = useState(value);

    function handleChange(value) {
      // console.log({ value });
      // set selected item
      setSelectedValue(value);

      // set form value
      if (onChange) {
        onChange(value);
      }

      // return event values
      if (getEvent) {
        const selectedItem = options
          ? options.filter((item) => item.value == value)
          : [];
        const target = {
          name,
          value,
          rules: { required: rest?.required },
          selectedItem,
        };

        getEvent({ target });
      }
    }

    // array to Object conversion
    const toObject = (data) => {
      const result = [];
      for (let i = 0; i < data.length; ++i) {
        const obj = {};
        obj.label = data[i];
        obj.value = data[i];
        result.push(obj);
      }
      return result;
    };

    // fetch data
    const fetchData = async () => {
      setLoading(true);
      if (slug.indexOf(",") > -1) {
        const options = toObject(slug.split(","));
        setOptions(convertOptions(options));
      } else {
        const response = await fetchWrapper.post("dropdown/dropdowndata", {
          dropdown_slug: slug,
          external_data: extra ? apsisEncrypt(extra) : "",
        });

        if (!response.error && response.data) {
          setOptions(convertOptions(response.data));
          if (response.data.length === 1 && defaultSelect) {
            handleChange(response.data[0].value);
          }
        }
      }
      setLoading(false);
    };

    const convertOptions = (opts) => {
      const oldValues = [...opts];
      return oldValues.map((item) => ({
        ...item,
        disabled: disabledOptions
          .map((item) => String(item))
          .includes(String(item.value)),
      }));
    };

    useEffect(() => {
      if (slug && slug != "") {
        fetchData();
      } else if (dropdownOptions && dropdownOptions != "") {
        const options = JSON.parse(dropdownOptions);
        setOptions(convertOptions(options));
      }
    }, [extra, dropdownOptions, slug]);

    useEffect(() => {
      setSelectedValue(
        /^\d+$/.test(value) && selectValueConvertNumber ? Number(value) : value
      );
    }, [value]);

    useEffect(() => {
      disabledOptions.length > 0 &&
        options.length > 0 &&
        setOptions(convertOptions(options));
    }, [disabledOptions]);

    return (
      <Select
        style={{
          width: "100%",
          ...(errors ? { border: "1px solid red" } : {}),
        }}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        showSearch
        allowClear
        status={errors ? "error" : ""}
        placeholder={rest.placeholder ?? "Please select"}
        optionFilterProp="children"
        name={name || "option_name"}
        onChange={handleChange}
        filterOption={(input, option) =>
          option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
        }
        value={selectedValue}
        loading={loading ?? false}
        {...rest}
        ref={ref}
      >
        {options?.map((opt, i) => (
          <Option
            disabled={opt.disabled}
            key={i.toString(36) + i}
            value={
              /^\d+$/.test(opt.value) && selectValueConvertNumber
                ? Number(opt.value)
                : opt.value
            }
          >
            {opt.label || ""}
          </Option>
        ))}
      </Select>
    );
  }
);
export default FormSelect;
